export var AidType;
(function (AidType) {
    AidType[AidType["Ay"] = 1] = "Ay";
    AidType[AidType["Ak"] = 2] = "Ak";
    AidType[AidType["C"] = 3] = "C";
    AidType[AidType["B"] = 4] = "B";
})(AidType || (AidType = {}));
